/* tslint:disable */
/* eslint-disable */
/**
 * CVPnet API
 * The CVPnet API allows you to retrieve preprocessed data of your club as well as writing back into CVPnet for specific use cases. Write functions containing input validation as well as a wide range of optional parameters. To use the interface, you must first activate it in CVPnet and create an API key for a user. Define rights for the API user to limit the API calls.    If more api calls are required feel free to contact us.
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var EventType;
(function (EventType) {
    EventType[EventType["NUMBER_0"] = 0] = "NUMBER_0";
    EventType[EventType["NUMBER_1"] = 1] = "NUMBER_1";
    EventType[EventType["NUMBER_2"] = 2] = "NUMBER_2";
    EventType[EventType["NUMBER_3"] = 3] = "NUMBER_3";
    EventType[EventType["NUMBER_4"] = 4] = "NUMBER_4";
})(EventType || (EventType = {}));
/**
 * HaKuBuApi - axios parameter creator
 * @export
 */
export const HaKuBuApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCalculateHallRent: (clubNumber, hallId, date, from, to, fullTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'clubNumber', clubNumber);
            // verify required parameter 'hallId' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'hallId', hallId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'date', date);
            // verify required parameter 'from' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'to', to);
            // verify required parameter 'fullTime' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'fullTime', fullTime);
            const localVarPath = `/api/HaKuBu/{clubNumber}/CalculateHallRent`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (hallId !== undefined) {
                localVarQueryParameter['hallId'] = hallId;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (fullTime !== undefined) {
                localVarQueryParameter['fullTime'] = fullTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCapturePaypalOrder: (clubNumber, captureOrderInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuCapturePaypalOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/Paypal/CaptureOrder/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(captureOrderInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCheckPersonalDataForHallBooking: (clubNumber, hallId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuCheckPersonalDataForHallBooking', 'clubNumber', clubNumber);
            // verify required parameter 'hallId' is not null or undefined
            assertParamExists('haKuBuCheckPersonalDataForHallBooking', 'hallId', hallId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/CheckPersonalDataForHallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (hallId !== undefined) {
                localVarQueryParameter['hallId'] = hallId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCreatePaypalOrder: (clubNumber, createOrderInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuCreatePaypalOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/Paypal/CreateOrder/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuDeleteHallBookings: (clubNumber, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuDeleteHallBookings', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/HallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ids, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseAdditionalDetails: (clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetClubCourseAdditionalDetails', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuGetClubCourseAdditionalDetails', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/ClubCourseAdditionalDetails/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseConfig: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetClubCourseConfig', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/ClubCourseConfig/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourses: (onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onlyNewCourses' is not null or undefined
            assertParamExists('haKuBuGetClubCourses', 'onlyNewCourses', onlyNewCourses);
            // verify required parameter 'maxCourseNumber' is not null or undefined
            assertParamExists('haKuBuGetClubCourses', 'maxCourseNumber', maxCourseNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetClubCourses', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/ClubCourses/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (onlyNewCourses !== undefined) {
                localVarQueryParameter['onlyNewCourses'] = onlyNewCourses;
            }
            if (maxCourseNumber !== undefined) {
                localVarQueryParameter['maxCourseNumber'] = maxCourseNumber;
            }
            if (freePlacesType !== undefined) {
                localVarQueryParameter['freePlacesType'] = freePlacesType;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubData: (logoWidth, logoHeigth, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'logoWidth' is not null or undefined
            assertParamExists('haKuBuGetClubData', 'logoWidth', logoWidth);
            // verify required parameter 'logoHeigth' is not null or undefined
            assertParamExists('haKuBuGetClubData', 'logoHeigth', logoHeigth);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetClubData', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/GetClubData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (logoWidth !== undefined) {
                localVarQueryParameter['logoWidth'] = logoWidth;
            }
            if (logoHeigth !== undefined) {
                localVarQueryParameter['logoHeigth'] = logoHeigth;
            }
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetConfig: (vereinsNummer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vereinsNummer' is not null or undefined
            assertParamExists('haKuBuGetConfig', 'vereinsNummer', vereinsNummer);
            const localVarPath = `/api/HaKuBu/GetConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (vereinsNummer !== undefined) {
                localVarQueryParameter['vereinsNummer'] = vereinsNummer;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseDetails: (clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetCourseDetails', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuGetCourseDetails', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/CourseDetails/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (onlyFutureMeetings !== undefined) {
                localVarQueryParameter['onlyFutureMeetings'] = onlyFutureMeetings;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseMeetings: (clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetCourseMeetings', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuGetCourseMeetings', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/GetCourseMeetings/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            if (onlyFutureMeetings !== undefined) {
                localVarQueryParameter['onlyFutureMeetings'] = onlyFutureMeetings;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetFreeDates: (clubNumber, id, date, from, to, duration, fullTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetFreeDates', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('haKuBuGetFreeDates', 'id', id);
            // verify required parameter 'date' is not null or undefined
            assertParamExists('haKuBuGetFreeDates', 'date', date);
            const localVarPath = `/api/HaKuBu/{clubNumber}/{id}/FreeDates`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }
            if (fullTime !== undefined) {
                localVarQueryParameter['fullTime'] = fullTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHallDetails: (clubNumber, id, withClubWithoutLogins, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetHallDetails', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('haKuBuGetHallDetails', 'id', id);
            const localVarPath = `/api/HaKuBu/{clubNumber}/{id}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHalls: (maxHallNumber, clubNumber, bookings, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maxHallNumber' is not null or undefined
            assertParamExists('haKuBuGetHalls', 'maxHallNumber', maxHallNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetHalls', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxHallNumber !== undefined) {
                localVarQueryParameter['maxHallNumber'] = maxHallNumber;
            }
            if (bookings !== undefined) {
                localVarQueryParameter['bookings'] = bookings;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetNextHallMeetings: (maxMeetingNumber, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maxMeetingNumber' is not null or undefined
            assertParamExists('haKuBuGetNextHallMeetings', 'maxMeetingNumber', maxMeetingNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetNextHallMeetings', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/NextHallMeetings`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxMeetingNumber !== undefined) {
                localVarQueryParameter['maxMeetingNumber'] = maxMeetingNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPaymentOptions: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetPaymentOptions', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/PaymentOptions/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} adressNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPermissions: (clubNumber, adressNummer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetPermissions', 'clubNumber', clubNumber);
            // verify required parameter 'adressNummer' is not null or undefined
            assertParamExists('haKuBuGetPermissions', 'adressNummer', adressNummer);
            const localVarPath = `/api/HaKuBu/GetPermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            if (adressNummer !== undefined) {
                localVarQueryParameter['adressNummer'] = adressNummer;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPersonalCourses: (meetingType, clubNumber, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'meetingType' is not null or undefined
            assertParamExists('haKuBuGetPersonalCourses', 'meetingType', meetingType);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetPersonalCourses', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/PersonalCourses/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (meetingType !== undefined) {
                localVarQueryParameter['meetingType'] = meetingType;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuHallBooking: (clubNumber, hallAppointment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuHallBooking', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/HallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(hallAppointment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuLoadPersonalData: (clubNumber, withPhoto, photoWidth, photoHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuLoadPersonalData', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/PersonalData`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withPhoto !== undefined) {
                localVarQueryParameter['withPhoto'] = withPhoto;
            }
            if (photoWidth !== undefined) {
                localVarQueryParameter['photoWidth'] = photoWidth;
            }
            if (photoHeigth !== undefined) {
                localVarQueryParameter['photoHeigth'] = photoHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPersonenLogin: (personenLogin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/HaKuBu/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(personenLogin, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseBooking: (clubNumber, saveBookingData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuPostSaveCourseBooking', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/SaveCourseBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveBookingData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseReservation: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuPostSaveCourseReservation', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuPostSaveCourseReservation', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/SaveCourseReservation/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseBooking: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuRemoveCourseBooking', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuRemoveCourseBooking', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/RemoveCourseBooking/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseReservation: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuRemoveCourseReservation', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuRemoveCourseReservation', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/RemoveCourseReservation/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuVereinsLogin: (vereinsLogin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/HaKuBu/VereinsLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(vereinsLogin, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * HaKuBuApi - functional programming interface
 * @export
 */
export const HaKuBuApiFp = function (configuration) {
    const localVarAxiosParamCreator = HaKuBuApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuDeleteHallBookings(clubNumber, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuDeleteHallBookings(clubNumber, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseConfig(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetClubCourseConfig(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetConfig(vereinsNummer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetConfig(vereinsNummer, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPaymentOptions(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetPaymentOptions(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} adressNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPermissions(clubNumber, adressNummer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetPermissions(clubNumber, adressNummer, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuHallBooking(clubNumber, hallAppointment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuHallBooking(clubNumber, hallAppointment, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPersonenLogin(personenLogin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuPersonenLogin(personenLogin, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseReservation(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuPostSaveCourseReservation(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseBooking(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuRemoveCourseBooking(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseReservation(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuRemoveCourseReservation(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuVereinsLogin(vereinsLogin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuVereinsLogin(vereinsLogin, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * HaKuBuApi - factory interface
 * @export
 */
export const HaKuBuApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HaKuBuApiFp(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
            return localVarFp.haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options) {
            return localVarFp.haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
            return localVarFp.haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options) {
            return localVarFp.haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuDeleteHallBookings(clubNumber, ids, options) {
            return localVarFp.haKuBuDeleteHallBookings(clubNumber, ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
            return localVarFp.haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseConfig(clubNumber, options) {
            return localVarFp.haKuBuGetClubCourseConfig(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
            return localVarFp.haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options) {
            return localVarFp.haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetConfig(vereinsNummer, options) {
            return localVarFp.haKuBuGetConfig(vereinsNummer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
            return localVarFp.haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
            return localVarFp.haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
            return localVarFp.haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
            return localVarFp.haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options) {
            return localVarFp.haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
            return localVarFp.haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPaymentOptions(clubNumber, options) {
            return localVarFp.haKuBuGetPaymentOptions(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} adressNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPermissions(clubNumber, adressNummer, options) {
            return localVarFp.haKuBuGetPermissions(clubNumber, adressNummer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
            return localVarFp.haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuHallBooking(clubNumber, hallAppointment, options) {
            return localVarFp.haKuBuHallBooking(clubNumber, hallAppointment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
            return localVarFp.haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPersonenLogin(personenLogin, options) {
            return localVarFp.haKuBuPersonenLogin(personenLogin, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options) {
            return localVarFp.haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseReservation(clubNumber, courseId, options) {
            return localVarFp.haKuBuPostSaveCourseReservation(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseBooking(clubNumber, courseId, options) {
            return localVarFp.haKuBuRemoveCourseBooking(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseReservation(clubNumber, courseId, options) {
            return localVarFp.haKuBuRemoveCourseReservation(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuVereinsLogin(vereinsLogin, options) {
            return localVarFp.haKuBuVereinsLogin(vereinsLogin, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HaKuBuApi - object-oriented interface
 * @export
 * @class HaKuBuApi
 * @extends {BaseAPI}
 */
export class HaKuBuApi extends BaseAPI {
    /**
     *
     * @param {number} clubNumber
     * @param {string} hallId
     * @param {string} date
     * @param {string} from
     * @param {string} to
     * @param {boolean} fullTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
        return HaKuBuApiFp(this.configuration).haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {PayPalCaptureOrderInput} [captureOrderInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options) {
        return HaKuBuApiFp(this.configuration).haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} hallId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
        return HaKuBuApiFp(this.configuration).haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {PayPalCreateOrderInput} [createOrderInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options) {
        return HaKuBuApiFp(this.configuration).haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuDeleteHallBookings(clubNumber, ids, options) {
        return HaKuBuApiFp(this.configuration).haKuBuDeleteHallBookings(clubNumber, ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [withClubWithoutLogins]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetClubCourseConfig(clubNumber, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetClubCourseConfig(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} onlyNewCourses
     * @param {number} maxCourseNumber
     * @param {number} clubNumber
     * @param {number} [freePlacesType]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} logoWidth
     * @param {number} logoHeigth
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} vereinsNummer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetConfig(vereinsNummer, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetConfig(vereinsNummer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [onlyFutureMeetings]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [withClubWithoutLogins]
     * @param {boolean} [onlyFutureMeetings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {string} date
     * @param {string} [from]
     * @param {string} [to]
     * @param {number} [duration]
     * @param {boolean} [fullTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {boolean} [withClubWithoutLogins]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} maxHallNumber
     * @param {number} clubNumber
     * @param {number} [bookings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} maxMeetingNumber
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetPaymentOptions(clubNumber, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetPaymentOptions(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} adressNummer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetPermissions(clubNumber, adressNummer, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetPermissions(clubNumber, adressNummer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} meetingType
     * @param {number} clubNumber
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {HallAppointment} [hallAppointment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuHallBooking(clubNumber, hallAppointment, options) {
        return HaKuBuApiFp(this.configuration).haKuBuHallBooking(clubNumber, hallAppointment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {boolean} [withPhoto]
     * @param {number} [photoWidth]
     * @param {number} [photoHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonenLoginViewModel} [personenLogin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuPersonenLogin(personenLogin, options) {
        return HaKuBuApiFp(this.configuration).haKuBuPersonenLogin(personenLogin, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {ClubCourseSaveBookingData} [saveBookingData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options) {
        return HaKuBuApiFp(this.configuration).haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuPostSaveCourseReservation(clubNumber, courseId, options) {
        return HaKuBuApiFp(this.configuration).haKuBuPostSaveCourseReservation(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuRemoveCourseBooking(clubNumber, courseId, options) {
        return HaKuBuApiFp(this.configuration).haKuBuRemoveCourseBooking(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuRemoveCourseReservation(clubNumber, courseId, options) {
        return HaKuBuApiFp(this.configuration).haKuBuRemoveCourseReservation(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VereinsLoginViewModel} [vereinsLogin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuVereinsLogin(vereinsLogin, options) {
        return HaKuBuApiFp(this.configuration).haKuBuVereinsLogin(vereinsLogin, options).then((request) => request(this.axios, this.basePath));
    }
}
